// removed by extract-text-webpack-plugin
module.exports = {"trafficReport":"ApIv4kGsZMC6v-4MCGtRt","searchContainer":"_2xCvgp01j1z08rpYOjy7MU","formContainer":"_2DSzXVAil65FqHri2GHC-S"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/TrafficReport/TrafficReport.less
// module id = 1530
// module chunks = 0